<template>
    <div class="tw-container">
      <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <form class="form" @submit.prevent="handleSubmit(formSubmit)" novalidate>
          <div class="progress-bar-container">
            <div class="tw-container">
              <div class="bar">
                <div class="progress" :style="`width: ${progressPercent}%`">
                  <div class="ball"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="step" v-if="$store.state.formStep === 1">
            <div class="question">Quantos veículos tem a sua frota?</div>
            <div class="tw-pb-3">
              <div class="button-form" @click="vehicles = '1'; $store.state.formStep++;" :class="{ 'active' : vehicles == '1' }">
                <p class=""><b>1</b></p>
              </div>
              <div class="button-form" @click="vehicles = '2_5'; $store.state.formStep++;" :class="{ 'active' : vehicles == '2_5' }">
                <p class=""><b>2 a 5</b></p>
              </div>
              <div class="button-form" @click="vehicles = '6_10'; $store.state.formStep++;" :class="{ 'active' : vehicles == '6_10' }">
                <p class=""><b>6 a 10</b></p>
              </div>
              <div class="button-form" @click="vehicles = '+11'; $store.state.formStep++;" :class="{ 'active' : vehicles == '+10' }">
                <p class=""><b>Mais de 10</b></p>
              </div>
            </div>
          </div>
          <div class="step" v-if="$store.state.formStep === 2">
            <div class="question">Qual o tipo de combustível mais usado?</div>
            <div class="tw-pb-3">
              <div class="button-form" @click="fuel = 'Gasóleo'; $store.state.formStep++;" :class="{ 'active' : fuel == 'Gasóleo' }">
                <p class=""><b>Gasóleo</b></p>
              </div>
              <div class="button-form" @click="fuel = 'Gasolina'; $store.state.formStep++;" :class="{ 'active' : fuel == 'Gasolina' }">
                <p class=""><b>Gasolina</b></p>
              </div>
              <div class="button-form" @click="fuel = 'GPL'; $store.state.formStep++;" :class="{ 'active' : fuel == 'GPL' }">
                <p class=""><b>GPL</b></p>
              </div>
              <div class="button-form" @click="fuel = 'Híbrido'; $store.state.formStep++;" :class="{ 'active' : fuel == 'Híbrido' }">
                <p class=""><b>Híbrido</b></p>
              </div>
              <div class="button-form" @click="fuel = 'Elétrico/Carregamentos'; $store.state.formStep++;" :class="{ 'active' : fuel == 'Elétrico/Carregamentos' }">
                <p class=""><b>Elétrico/Carregamentos</b></p>
              </div>
            </div>
          </div>
          <div class="step" v-if="$store.state.formStep === 3">
            <div class="question">Qual o consumo médio mensal de combustível da frota?</div>
            <div class="tw-pb-3">
              <div class="button-form" @click="mpg = 'MENOS_3000'; $store.state.formStep++;" :class="{ 'active' : mpg == 'MENOS_3000' }">
                <p class=""><b>Menos de 3000 litros/mês</b></p>
              </div>
              <div class="button-form" @click="mpg = 'MAIS_3000'; $store.state.formStep++;" :class="{ 'active' : mpg == 'MAIS_3000' }">
                <p class=""><b>Mais de a 3000 litros/mês</b></p>
              </div>
            </div>
          </div>

          <div class="step" v-if="$store.state.formStep === 4">
            <div class="question tw-mt-1 lg:tw-px-3">Para receber a simulação preencha os dados</div>
            <fieldset class="tw-px-6 lg:tw-px-3 tw-pb-3">
              <div class="tw-flex tw-flex-col tw-gap-0 lg:tw-flex-row lg:tw-gap-2">
                <validation-provider class="tw-w-full tw-w-block" name="company" rules="required" v-slot="{ classes }">
                  <div class="input-group input-group-company" :class="classes">
                    <input type="text"
                           id="input-company"
                           placeholder=" "
                           v-model="formCompany"
                    >
                    <label>
                      Nome da Empresa
                    </label>
                  </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" name="nif" rules="required|nif" v-slot="{ classes }">
                  <div class="input-group input-group-nif" :class="classes">
                    <input type="tel"
                           id="input-nif"
                           placeholder=" "
                           v-model="nif"
                           v-mask="{mask: '999999999', placeholder:' '}"
                    >
                    <label>
                      NIF da Empresa
                    </label>
                  </div>
                </validation-provider>
              </div>

              <div class="tw-flex tw-flex-col tw-gap-0 lg:tw-flex-row lg:tw-gap-2">
                <validation-provider class="tw-w-full tw-w-block" name="fullName" rules="required|alpha_spaces" v-slot="{ classes }">
                  <div class="input-group input-group-name" :class="classes">
                    <input type="text"
                           id="input-fullName"
                           placeholder=" "
                           v-model="fullName"
                    >
                    <label>
                      O seu nome e apelido
                    </label>
                  </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" name="phone" rules="required|phone:pt" v-slot="{ classes }">
                  <div class="input-group input-group-phone" :class="classes">
                    <input type="tel"
                           id="input-phone"
                           placeholder=" "
                           v-model="phone"
                           v-mask="{mask: '999999999', placeholder:' '}"
                    >
                    <label>
                      Telefone
                    </label>
                  </div>
                </validation-provider>
              </div>

              <validation-provider class="tw-w-full tw-w-block" name="email" rules="required|email" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', email: 'inválido' }">
                <div class="input-group input-group-email" :class="classes">
                  <input type="email"
                         id="input-email"
                         placeholder=" "
                         v-model.lazy="email"
                  >
                  <label>
                    Email {{ errors [0]}}
                  </label>
                </div>
              </validation-provider>

              <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
                <div class="mb-2">
                  <div class="form-check p-0">
                    <label class="form-check-label" :class="classes">
                      <input class="form-check-input" type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                      <span class="checkmark"></span>
                      <span class="tw-text-left lg:tw-text-left">Autorizo a {{ company }} a utilizar os meus dados para ser contactado segundo a sua <a href="#" @click.prevent="$store.state.modal.terms = true"><u>política de privacidade</u></a>.</span>
                    </label>
                  </div>
                </div>
              </validation-provider>
              <div class="tw-text-center !tw-rounded-full !tw-w-full tw-mt-4">
                <button
                    type="submit"
                    class="btn-cta tw-mx-auto"
                    id="submit"
                    :disabled="formLoading"
                >
                  Receber simulação
                </button>
              </div>
            </fieldset>
          </div>
        </form>
      </validation-observer>
    </div>
</template>

<script>
import axios from 'axios';
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';
import '@/validations/nif';

export default {
    name: 'FormComponent',
    data() {
        return {
            fullName: '',
            phone: '',
            email: '',
            mpg: '',
            fuel: '',
            vehicles: '',
            city: '',
            formCompany: '',
            nif: '',

            step: 1,
            formLoading: false,
            usedClasses: ['.has-error'],
            company: process.env.VUE_APP_COMPANY,
            steps: 4,
        };
    },
    computed: {
        progressPercent() {
            if (this.$store.state.formSteps <= 1) return 100;
            const pct = ((this.$store.state.formStep - 1) / (this.$store.state.formSteps - 1)) * 100;
            return Math.round(Math.min(100, Math.max(0, pct)));
        },
    },
    methods: {
        formSubmit() {
            this.formLoading = true;

            let cmpInfo = {
                vendor: {
                    consents: [],
                },
                tcString: '',
            };

            try {
                cmpInfo = __tcfapi('getTCData');
            } catch (e) {
                console.log('No CMP Info');
            }

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                cible: this.$route.query.cible,
                pubid: this.$route.query.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                token: this.$store.state.token,
                mclic: process.env.VUE_APP_MCLIC,

                fullName: this.fullName.toUpperCase(),
                phone: this.phone,
                email: this.email.toUpperCase(),
                mpg: this.mpg.toUpperCase(),
                fuel: this.fuel.toUpperCase(),
                vehicles: this.vehicles.toUpperCase(),
                city: this.city.toUpperCase(),
                company: this.formCompany.toUpperCase(),
                nif: this.nif,

                consent: cmpInfo.vendor.consents.hasOwnProperty('702'),
                tcString: cmpInfo.tcString,
            };

            axios.post(action, data)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                })
                .catch((error) => {
                    this.formLoading = false;
                    if (error.response.data.errors.email) {
                        error.response.data.errors.email = 'já registado';
                    }
                    console.log(error.response.data.errors);
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
@import '~@/assets/scss/partials/_fonts.scss';

fieldset {

  @screen lg {
    max-width: 700px;
  }
}

.progress-bar-container {
  @apply tw-py-8;

  @screen lg {
    @apply tw-py-16;
  }

  .bar {
    @apply tw-w-full tw-mx-auto tw-relative tw-rounded-full;
    height: 6px;
    background-color: rgba(#313133, .1);

    .progress {
      @apply tw-transition-all tw-relative tw-w-0 tw-h-full tw-rounded-full;
      transition: width 0.3s ease-in-out;
      background-color: #B80059;

      .ball {
        @apply tw-absolute tw-rounded-full tw-w-5 tw-h-5 tw-pointer-events-none tw-right-0;
        top: 50%;
        transform: translateY(-50%);
        background-color: #B80059;
      }
    }
  }
}

.question {
  @apply tw-font-bold tw-mb-3 tw-mx-0 tw-text-center;
  font-size: 20px;
  color: #2C3C53;
  font-family: $font_bold;

  @screen lg {
    @apply tw-mx-0 tw-text-left;
    font-size: 24px;
  }
}

.button-form {
  @apply tw-relative tw-rounded-full tw-outline-none tw-cursor-pointer tw-py-4 tw-transition-all tw-text-left tw-mb-2 tw-w-full tw-mx-auto;
  background-color: rgba(#008EAA, .05);
  border: solid 1px #008EAA;
  color: #008EAA;
  height: 60px;

  @screen lg {
    @apply tw-mx-0 tw-py-4 tw-h-auto;
    width: 500px;
  }

  &:hover {
    color: #FFF;
    background-color: #008EAA;

    &::before {
      content: url("data:image/svg+xml,%3Csvg width='32' height='17' viewBox='0 0 32 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M31.7885 7.52685L24.5159 0.254223C24.2547 -0.0508341 23.7956 -0.0863958 23.4905 0.174912C23.1855 0.436158 23.1499 0.895274 23.4112 1.20033C23.4356 1.22877 23.4621 1.25533 23.4905 1.27964L29.5195 7.31591H0.727237C0.325619 7.31591 0 7.64153 0 8.04321C0 8.44489 0.325619 8.77045 0.727237 8.77045H29.5195L23.4905 14.7994C23.1855 15.0607 23.1499 15.5198 23.4112 15.8248C23.6725 16.1299 24.1316 16.1654 24.4366 15.9041C24.4651 15.8798 24.4916 15.8533 24.5159 15.8248L31.7886 8.5522C32.0705 8.26865 32.0705 7.81053 31.7885 7.52685Z' fill='white'/%3E%3C/svg%3E%0A");
    }
  }

  p {
    @apply tw-transition-all tw-font-bold;
    margin-right: auto;
    margin-left: 40px;
    font-size: 16px;

    @screen lg {
      font-size: 24px;
    }
  }

  &::before {
    content: url("data:image/svg+xml,%3Csvg width='32' height='17' viewBox='0 0 32 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M31.7885 7.52685L24.5159 0.254223C24.2547 -0.0508341 23.7956 -0.0863958 23.4905 0.174912C23.1855 0.436158 23.1499 0.895274 23.4112 1.20033C23.4356 1.22877 23.4621 1.25533 23.4905 1.27964L29.5195 7.31591H0.727237C0.325619 7.31591 0 7.64153 0 8.04321C0 8.44489 0.325619 8.77045 0.727237 8.77045H29.5195L23.4905 14.7994C23.1855 15.0607 23.1499 15.5198 23.4112 15.8248C23.6725 16.1299 24.1316 16.1654 24.4366 15.9041C24.4651 15.8798 24.4916 15.8533 24.5159 15.8248L31.7886 8.5522C32.0705 8.26865 32.0705 7.81053 31.7885 7.52685Z' fill='%23008EAA'/%3E%3C/svg%3E%0A");
    @apply tw-absolute;
    right: 20px;
    top: 55%;
    transform: translateY(-50%);
  }
}
</style>
